// extracted by mini-css-extract-plugin
export default {"bioContainer":"Alojamiento_bioContainer__DGd-B","bioimg":"Alojamiento_bioimg__tfD7t","libro":"Alojamiento_libro__qr5ab","bio":"Alojamiento_bio__Id+yG"};